export default {
  'financial.billsToPay.label.status': 'Situação',
  'financial.billsToPay.label.filterByDate': 'Filtrar por data de',
  'financial.billsToPay.label.reportType': 'Selecionar o tipo de relatório',
  'financial.billsToPay.label.show': 'Exibir:',
  'financial.billsToPay.label.moreOptions': 'Mais Opções',
  'financial.billsToPay.label.accountPlans': 'Plano de Contas',
  'financial.billsToPay.label.documentType': 'Tipo de Documento',
  'financial.billsToPay.label.costCenter': 'Centro de Custo',
  'financial.billsToPay.label.bankAccount': 'Conta Bancária',

  'financial.billsToPay.option.open': 'Abertos',
  'financial.billsToPay.option.liquidated': 'Liquidados',
  'financial.billsToPay.option.emission': 'Emissão',
  'financial.billsToPay.option.expiration': 'Vencimento',
  'financial.billsToPay.option.payment': 'Pagamento',
  'financial.billsToPay.option.accountPlans': 'Planos de Contas',
  'financial.billsToPay.option.bankAccount': 'Conta Bancária',

  'financial.billsToPay.checkbox.synthetic': 'Sintético?',
  'financial.billsToPay.checkbox.billsToPay': 'Contas a pagar',
  'financial.billsToPay.checkbox.tariffs': 'Tarifas',

  'financial.billsToPay.button.selectSuppliers': 'Selecionar fornecedores',
  'financial.billsToPay.button.selectEmployees': 'Selecionar funcionários',

  'domain.enums.situation_installment_payable.open': 'Aberta',
  'domain.enums.situation_installment_payable.settled': 'Liquidada',

  'financial.billsToPay.create.success.title': 'Sucesso',
  'financial.billsToPay.create.success.content': 'Parcela criada com sucesso!',

  'financial.billsToPay.update.success.title': 'Sucesso',
  'financial.billsToPay.update.success.content':
    'Contas a pagar atualizada com sucesso!',

  'financial.billsToPay.cancel.success.title': 'Confirmação',
  'financial.billsToPay.cancel.success.content':
    'O processo de exclusão de parcelas é irreversível. Deseja realmente excluir a parcela?',
  'financial.billsToPay.cancel.success.content.commision':
    'Ao excluir a última parcela do conta a pagar vinculada a comissão, o valor será automaticamente estornado. Deseja continuar com a exclusão?',
  'financial.billsToPay.notifications.remove.success.title': 'Sucesso!',
  'financial.billsToPay.notifications.remove.success.description':
    'Parcela foi excluida com sucesso!',

  'financial.billsToPay.detail.button.newAccountPayable': 'Nova Conta a Pagar',
  'financial.billsToPay.detail.button.parcel': 'Parcelamento',
  'financial.billsToPay.detail.button.renegotiate': 'Renegociar',
  'financial.billsToPay.detail.button.observation': 'Nova Observação',
  'financial.billsToPay.detail.button.observationSave': 'Salvar Observação',
  'financial.billsToPay.detail.button.observationEdit': 'Editar Observação',
  'financial.billsToPay.detail.button.settleInstallment': 'Liquidar Parcela',
  'financial.billsToPay.detail.button.partiallyLiquidate':
    'Liquidar Parcialmente',
  'financial.billsToPay.detail.button.reverseInstallment': 'Estornar Parcela',

  'financial.billsToPay.notifications.settledSingle.success.title': 'Sucesso!',
  'financial.billsToPay.notifications.settledSingle.success.description':
    'Parcela foi liquidada com sucesso',

  'financial.billsToPay.notifications.settledPartially.success.title':
    'Sucesso!',
  'financial.billsToPay.notifications.settledPartially.success.description':
    'Parcela foi liquidada parcialmente com sucesso',

  'financial.billsToPay.notifications.settledMultiple.success.title':
    'Sucesso!',
  'financial.billsToPay.notifications.settledMultiple.success.description':
    'Parcelas liquidadas com sucesso!',

  'financial.billsToPay.notifications.splitInstallment.success.title':
    'Sucesso!',
  'financial.billsToPay.notifications.splitInstallment.success.description':
    'Parcelamento da parcela feita com sucesso!',

  'financial.billsToPay.notifications.renegotiateInstallment.success.title':
    'Sucesso!',
  'financial.billsToPay.notifications.renegotiatInstallment.success.description':
    'Renegociação feita com sucesso!',
};
